// =============================================================
// Link giới thiệu (affiliate) của nhân viên.
// Mỗi nhân viên có 1 mã 8 ký tự chữ + số, link có dạng:
//   <domain FE>/gioi-thieu/<mã>
// Người mới bấm vào link sẽ tự đăng ký tài khoản theo đúng luồng
// "Giới thiệu việc làm" của app.
// =============================================================

export const AFFILIATE_BASE_PATH = "/gioi-thieu";

export const buildAffiliateLink = (affiliateCode) => {
  if (!affiliateCode) return "";

  const origin =
    typeof window !== "undefined" && window.location?.origin
      ? window.location.origin
      : "";

  return `${origin}${AFFILIATE_BASE_PATH}/${affiliateCode}`;
};

/**
 * Mở cửa sổ chia sẻ của hệ điều hành (giống nút share trên app), nếu trình duyệt
 * không hỗ trợ thì fallback sang copy vào clipboard.
 * Trả về: "shared" | "cancelled" | "copied" | "failed"
 */
export const shareOrCopyLink = async (link, { title, text } = {}) => {
  if (!link) return "failed";

  if (navigator?.share) {
    try {
      await navigator.share({ title, text, url: link });
      return "shared";
    } catch (error) {
      // Người dùng đóng cửa sổ chia sẻ thì không cần làm gì thêm
      if (error?.name === "AbortError") return "cancelled";
    }
  }

  return (await copyTextToClipboard(link)) ? "copied" : "failed";
};

/**
 * Copy text vào clipboard.
 * navigator.clipboard chỉ chạy ở https/localhost nên có fallback bằng
 * textarea + execCommand cho môi trường chạy http.
 */
export const copyTextToClipboard = async (text) => {
  if (!text) return false;

  try {
    if (navigator?.clipboard?.writeText && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch (error) {
    // rơi xuống fallback bên dưới
  }

  try {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.setAttribute("readonly", "");
    textarea.style.position = "fixed";
    textarea.style.top = "-1000px";
    document.body.appendChild(textarea);
    textarea.select();
    const copied = document.execCommand("copy");
    document.body.removeChild(textarea);
    return copied;
  } catch (error) {
    return false;
  }
};
